import { OrderedMap, Map } from 'immutable';
import HomeworkContentItem from './model';

import {
  FETCH_HOMEWORK_CONTENT_SUCCESS,
  ASSIGN_HOMEWORK_SUCCESS,
} from './actions';

export default function HomeworkContentReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_HOMEWORK_CONTENT_SUCCESS:
      return addHomeworkContentToMap(state, action);
    case ASSIGN_HOMEWORK_SUCCESS:
      return addHomeworkContentToMap(state, {
        ...action,
        payload: action.editedGroupHomeworkItems,
      });
    default:
      return state;
  }
}

function addHomeworkContentToMap(state, { payload, sessionId }) {
  let newState = state;
  newState = newState.set(`${sessionId}`,
      new OrderedMap(payload.reduce((pairs, activity) => {
        const contentItem = HomeworkContentItem.create(activity);
        const mapKey = `${contentItem.unitId}-${contentItem.lessonNumber}`;
        pairs.push([mapKey, contentItem]);
        return pairs;
      }, [])));
  return newState;
}



// WEBPACK FOOTER //
// ./data/Homework/Content/reducer.js